<template>
  <option-general value="immediately" :label="$t('edit.sidebar.immediately_when_access')"></option-general>
</template>

<script>
import OptionGeneral from './general/Main.vue';

export default {
  components: {
    OptionGeneral,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Immediately.vue?24b9b4c2
 **/